import DOMPurify from 'dompurify';

export const sanitizeHtml = (value = '') =>
  DOMPurify.sanitize(String(value), {
    USE_PROFILES: { html: true },
  });

export const sanitizeSvg = (value = '') =>
  DOMPurify.sanitize(String(value), {
    USE_PROFILES: { svg: true, svgFilters: true },
  });
